export default {
  common: {
    casino: "Kasino",
    more: "Lainnya",
    searchGames: "Cari permainan",
    copied: "Tersalin!",
    inputTooLong: "Masukan terlalu panjang, silakan masukkan ulang.",
    inputNameCn: "Hanya karakter Tionghoa, huruf, angka, dan garis bawah yang diperbolehkan",
    inputCapital: "Hanya huruf besar dan garis bawah yang diperbolehkan",
    inputLowercaseUnderscore: "Hanya huruf kecil dan garis bawah yang diperbolehkan",
    inputLowercase: "Hanya huruf kecil yang diperbolehkan",
    inputNoSpace: "Mohon jangan hanya memasukkan spasi",
    inputValidPhone: "Silakan masukkan nomor telepon yang valid",
    inputNonNumber: "Mengandung karakter non-angka",
    inputNonLetter: "Mengandung karakter non-huruf",
    inputLetterOrNumberOnly: "Hanya huruf atau angka yang diperbolehkan",
    phoneFormatError: "Format nomor telepon tidak valid",
    inputLetterStartNumber: "Harus diawali dengan huruf dan boleh mengandung angka",
    inputNoChinese: "Karakter Tionghoa tidak diperbolehkan",
    inputChineseOnly: "Hanya karakter Tionghoa yang diperbolehkan",
    emailFormatError: "Format email tidak valid",
    urlFormatError: "Format URL tidak valid",
    jsonFormatError: "Format JSON tidak valid",
    networkError: "Gagal terhubung ke server, silakan coba lagi nanti.",
    siteUnavailable: "Situs ini saat ini tidak tersedia, silakan hubungi administrator.",
    tokenExpired: "Sesi Anda telah berakhir, silakan masuk kembali.",
    domainNotAuthorized: "Domain tidak diizinkan",
    demoEnvOnly: "Lingkungan demo, hanya untuk pratinjau",
    passwordLength630: "6-30 karakter",
    newPasswordSameAsOld: "Kata sandi baru tidak boleh sama dengan kata sandi lama",
    confirmNewPassword: "Silakan konfirmasi kata sandi baru Anda",
    passwordsDoNotMatch: "Kata sandi tidak cocok",
    withdrawPasswordChanged: "Kata sandi penarikan berhasil diubah",
    withdrawPasswordSet: "Kata sandi penarikan berhasil diatur",
    withdrawPasswordSetFailed: "Gagal mengatur kata sandi penarikan",
    phoneDigitsOnly: "Nomor telepon harus berupa angka saja",
    phoneTooShort: "Nomor telepon terlalu pendek (min. {min} digit)",
    phoneTooLong: "Nomor telepon terlalu panjang (maks. {max} digit)",
    phoneInvalidPrefix: "Awalan nomor telepon tidak valid",
    rolloverAll: "Semua jenis",
    rolloverAllStats: "Semua Status",
    rolloverSuccessful: "Berhasil",
    rolloverFailed: "Gagal",
    rolloverInProgress: "Sedang Berlangsung",
    rolloverSuccess: "Berhasil",
    rolloverPending: "Tertunda",
    rolloverCompleted: "Selesai",
    rolloverCancelled: "Dibatalkan",
    rolloverExpired: "Kedaluwarsa",
    walletCash: "Tunai",
    walletBonus: "Bonus",
    sourceDeposit: "Deposit",
    sourceCommission: "Komisi",
    sourceManualAdd: "Tambah Manual",
    sourceManualSubtract: "Kurang Manual",
  },
  redeemCode: {
    enterTip: "Masukkan kode penukaran Anda untuk mengklaim hadiah",
    placeholder: "Silakan masukkan kode Anda",
    redeemBtn: "TUKAR",
    pleaseEnterCode: "Silakan masukkan kode penukaran Anda",
    redeemSuccess: "Penukaran berhasil!",
    redeemFailed: "Penukaran gagal, silakan coba lagi",
  },
}
